export const selectText = (v) => {
    if (!v) {
        return ['No information provided', 'color-medium'];
    }

    const val = v.toUpperCase();

    if (val == 'SOMETIMES') {
        return ['Sometimes', 'color-warn'];
    } else if (val == 'YES' || val == 'YES_CANNOT_CHANGE') {
        return ['Yes', 'color-red'];
    } else if (val == 'SAW_AND_HEARD') {
        return ['Saw and heard', 'color-warn'];
    } else if (val == 'SAW') {
        return ['Saw', 'color-warn'];
    } else if (val == 'HEARD') {
        return ['Heard', 'color-warn'];
    } else if (val == 'NOT_SURE') {
        return ['Not sure', 'color-warn'];
    } else if (val == 'NO') {
        return ['No', 'color-green'];
    }
};
